import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M15.435 2.5H4.565c-1.6 0-2.899 1.348-2.899 3.012v6.023c0 1.663 1.298 3.011 2.9 3.011h5.242c1.018 0 1.962.555 2.486 1.462l.65 1.127a.712.712 0 0 0 1.27-.051l.726-1.509a1.79 1.79 0 0 1 1.602-1.029c.99 0 1.791-.833 1.791-1.861V5.512c0-1.664-1.298-3.012-2.898-3.012Z"
    }, null, -1)
  ]))]))
}
export default { render: render }